// "Every app open" for the dashboard intro animation: a cold start, or any
// return from the background. Each client reports visibility from its own source
// (web `visibilitychange`, mobile `AppState`); this keeps the shared epoch.
// Mobile: call setAppVisible(false) only on AppState 'background', never on
// 'inactive' (iOS reports that for Control Center and the notification shade).
// The intro plays once per epoch, so remounting the dashboard (reader -> back)
// does not replay it, but coming back from the background does.

let epoch = 0;
let hidden = false;
let introEpoch = -1;
const listeners = new Set<() => void>();

export function setAppVisible(visible: boolean): void {
  if (!visible) {
    hidden = true;
    return;
  }
  if (!hidden) return;
  hidden = false;
  epoch += 1;
  listeners.forEach((l) => l());
}

export const getAppOpenEpoch = (): number => epoch;

export function subscribeAppOpen(listener: () => void): () => void {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}

/** True until the intro has played for this epoch. */
export const introPending = (forEpoch: number): boolean => introEpoch !== forEpoch;
export const markIntroPlayed = (forEpoch: number): void => {
  introEpoch = forEpoch;
};

export function resetAppOpenForTests(): void {
  epoch = 0;
  hidden = false;
  introEpoch = -1;
  listeners.clear();
}
